import styles from './DashboardWidgetWrapper.module.scss';
import { Button } from 'antd';
import { Icon } from '@app/ui';

interface DashboardWidgetWrapperProps {
  header?: React.ReactNode;
}

export function DashboardWidgetWrapper(props: React.PropsWithChildren<DashboardWidgetWrapperProps>) {
  const { header, children } = props;

  return (
    <div className={styles.widget}>
      {header}
      {children}
    </div>
  );
}

DashboardWidgetWrapper.ACTIONS = function dashboardWidgetWrapperActions(
  onDelete: () => void,
): React.ReactElement[] {
  return [
    <Button
      type="link"
      key="delete"
      icon={<Icon type="delete" />}
      danger
      onClick={(e) => {
        e.stopPropagation();
        onDelete();
      }}
      aria-label="Delete"
    />,
  ];
};
